/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from 'react-router-dom';
import Pagination from 'components/Pagination';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';
import ReactLoader from 'components/Loader';

import Service from '../service/index';

import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';
import { TagRecordType } from 'views/fieldConfigs/list/components/TableProtocolFields/TagRecordType/TagRecordType';

const ConfigStatusNotificationMessagesList = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [idResource, setidResource] = useState();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [searchUsers, setSearchUsers] = useState();
  const [messageNameSelected, setMessageNameSelected] = useState('');

  useEffect(() => {
    getMessages();
  }, []);

  const getUsersSearch = (event, selectedPage = 1) => {
    setSearchUsers(event.target.value);
    if (searchUsers) {
      getMessages(selectedPage, event.target.value);
    }
  };

  const getMessages = (selectedPage = 1, search = '') => {
    setLoading(true);
    Service.getAll(selectedPage, search)
      .then((res) => {
        const messages = res.data.content;
        const quantity = res.data.quantity;
        const newActivePage = selectedPage || activePage;
        setMessages(messages);
        setQuantity(quantity);
        setActivePage(newActivePage);
        setLoading(false);
      })
      .catch((error) => {
        const data = error?.response?.data;
        toast.error(data?.message || 'Ocorreu um erro ao buscar as mensagens', {
          autoClose: 3000,
          closeOnClick: true
        });
        setLoading(false);
      });
  };

  const handlePageChange = (activePage) => getMessages(activePage);

  const deleteMessage = (id) => {
    Service.delete(id)
      .then((res) => {
        const { data } = res;
        getMessages();
        toast.success(data.message, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch((error) => {
        const { data } = error.response;
        toast.error(data.message, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getMessages();
      });
  };

  const controlDelete = (id) => {
    setidResource(id);
    setOpenModalConfirmation(true);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/status/messages/notification/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">
                    Mensagens de notificação personalizada pra email
                  </h3>
                </CardHeader>
                <Row className="ml-2">
                  <Col md="10" mt="10">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText style={{ marginTop: '10px' }}>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Buscar mensagens..."
                        type="text"
                        onChange={(event) => getUsersSearch(event)}
                        style={{ marginTop: '10px' }}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                {messages && messages.length ? (
                  <ToolkitProvider
                    data={messages}
                    keyField="id"
                    columns={[
                      {
                        dataField: 'name',
                        text: 'Nome',
                        sort: true,
                        style: individual_column_style,
                        headerStyle: individual_header_style
                      },
                      {
                        dataField: 'recordTypes',
                        text: 'Tipos de registro',
                        sort: true,
                        style: individual_column_style,
                        headerStyle: individual_header_style,
                        formatter: (_, row) =>
                          row.RecordType ? (
                            <TagRecordType key={row.RecordType.id}>
                              {row.RecordType.name || ''}
                            </TagRecordType>
                          ) : (
                            ''
                          )
                      },
                      {
                        dataField: 'edit',
                        style: icon_column_style,
                        headerStyle: individual_icon_header_style,
                        text: 'Editar',
                        // eslint-disable-next-line react/display-name
                        formatter: (_, row) => {
                          return (
                            <Link
                              to={
                                '/admin/status/messages/notification/form/' +
                                row.id
                              }
                            >
                              <Button color="info" size="sm">
                                <li className="fas fa-user-edit"></li>
                              </Button>
                            </Link>
                          );
                        }
                      },

                      {
                        dataField: 'delete',
                        style: icon_column_style,
                        headerStyle: individual_icon_header_style,
                        text: 'deletar',
                        // eslint-disable-next-line react/display-name
                        formatter: (_, row) => {
                          return (
                            <Button
                              color="danger"
                              onClick={() => {
                                controlDelete(row.id);
                                setMessageNameSelected(row.name);
                              }}
                              size="sm"
                            >
                              <li className="fas fa-trash"></li>
                            </Button>
                          );
                        }
                      }
                    ]}
                  >
                    {(props) => (
                      <div className="py-4 table-responsive">
                        {loading ? (
                          <Row className="justify-content-md-center">
                            <ReactLoader />
                          </Row>
                        ) : (
                          <BootstrapTable
                            {...props.baseProps}
                            bootstrap4={true}
                            bordered={false}
                            classes="align-items-center"
                          />
                        )}
                      </div>
                    )}
                  </ToolkitProvider>
                ) : (
                  <div className="text-center mb-3 mt-3">
                    <span>
                      {loading ? (
                        <ReactLoader />
                      ) : (
                        'Nenhuma mensagem de notificação de status encontrada.'
                      )}
                    </span>
                  </div>
                )}

                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deleteMessage}
        messageContainsHtml={true}
        message={`<div style='font-size:15px;line-height:1.5;text-align:center;'>
          <div style='font-weight:500;margin-bottom:6px;'>Tem certeza que deseja excluir esta mensagem?</div>
          <div style='color:#888;font-size:14px;'>Mensagem a ser excluída:</div>
          <div style='margin:8px 0;font-weight:600;color:#d9534f;'>${messageNameSelected}</div>
        </div>`}
      />
    </>
  );
};

export default ConfigStatusNotificationMessagesList;
